module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('modal', {
    staticClass: "output_options-modal",
    attrs: {
      "width": "460px",
      "height": "130px",
      "backdrop": false,
      "value": _vm.showModal,
      "effect": "fade",
      "large": ""
    },
    on: {
      "closed": _vm.closed
    }
  }, [_c('div', {
    staticClass: "modal-header",
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_c('center', [_c('strong', [_vm._v(_vm._s(_vm.textTitle))])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "modal-body output_options-modal-body",
    staticStyle: {
      "height": "50px",
      "padding": "0px 15px",
      "overflow-x": "auto"
    }
  }, [_c('input', {
    ref: "local_value",
    staticClass: "form-control",
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "text",
      "id": "local_value",
      "name": "local_value",
      "placeholder": ""
    },
    domProps: {
      "value": _vm.localValue
    },
    on: {
      "input": function($event) {
        _vm.updateValue($event.target.value)
      },
      "keyup": function($event) {
        _vm.keyUp($event.target.id, $event.target.value, $event)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    staticStyle: {
      "background": "white"
    },
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.closed('no')
      }
    }
  }, [_vm._v("キャンセル")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.closed('yes')
      }
    }
  }, [_vm._v("完了")])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0a787a91","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/input-modal2.vue
// module id = 932
// module chunks = 0